module.exports = __webpack_public_path__ + "static/High-Contrast-Month-Template-86da8506b281f06e9ca2376fc7df14a3.png";